import { Company } from '../../types/plann3r'

export type PagesManagementStore = {
  companies: Company[],
  saving: boolean,
  active_company: number | null,
  active_page?: number | null,
  active_tab: PagesManagementTab | string | null,
  isFetching: boolean,
};

export enum PagesManagementTab {
  EDITOR = 'editor',
  PREFERENCES = 'preferences',
  AVAILABILITIES = 'availabilities',
  SHARE = 'share',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PagesManagementActionType = any;
